import { render, staticRenderFns } from "./TargetActions.vue?vue&type=template&id=0b108fea"
import script from "./TargetActions.vue?vue&type=script&lang=js"
export * from "./TargetActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports